import service from './service';
import uploadService from './uploadService';

export const getReasonsRiskManagers = async () => {
  const { data } = await service.get('/company/dispute-center/listing-reasons-risk-managers');
  const reasons = [];

  data.reasons.map((item) => {
    reasons.push({
      id: item.id,
      description: item.description,
      resolution_time: item.resolution_time,
      checked: false,
      mediation: item.mediation || false,
    });
  });

  return {
    reasons: reasons,
    riskManagers: data.risk_managers,
    user: data.user,
  };
};

export const createComplaint = async (body) => {
  body.custom_answers = body.custom_answers.filter((field) => field != false);
  const data = await service.post('/company/dispute-center', body);
  return data;
};

export const uploadAttachments = async (body: object) => {
  const data = await uploadService.post('/company/dispute-center/attachments', body);
  return data;
};

export const saveComplaintForm = async (body: object) => {
  const data = await service.post('/company/dispute-center/create-abandoned', body);
  return data;
};

export const createGRComplaint = async (body: object) => {
  const data = await service.post('/company/dispute-center/gr', body);
  return data;
};
